import Text from "../../text/Text";
import type { AvatarOption, ListItemHtmlProps } from "../../../types/Menu";
import ListItemContainer from "./ListItemContainer";
import { Avatar } from "../../avatar/Avatar";

type AvatarListItemProps = Omit<AvatarOption<null>, "variant" | "value"> & {
  htmlProps: ListItemHtmlProps | null;
};

const AvatarListItem = (props: AvatarListItemProps) => (
  <ListItemContainer htmlProps={props.htmlProps} disabled={props.disabled} hidden={props.hidden} type="row">
    <Avatar size="xs" shape={props.shape} backgroundColor={props.backgroundColor} value={props.initials} />
    <Text as="span" truncate text={props.label} class="text-base-regular text-primary group-disabled:text-disabled" />
  </ListItemContainer>
);

export default AvatarListItem;
